import { render } from "./CreateNewAdEngagementAudiance.vue?vue&type=template&id=2c285104&scoped=true"
import script from "./CreateNewAdEngagementAudiance.vue?vue&type=script&lang=js"
export * from "./CreateNewAdEngagementAudiance.vue?vue&type=script&lang=js"

import "./CreateNewAdEngagementAudiance.vue?vue&type=style&index=0&id=2c285104&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c285104"]])

export default __exports__